"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noop = void 0;
/**
 * Пустая функция, ничего не возвращает
 * @example
 * noop(1) // -> void
 */
var noop = function () { };
exports.noop = noop;
//# sourceMappingURL=noop.js.map